import React, { Component } from 'react';
import '../css/CommissionPayment.css';
import { Link } from 'react-router-dom';
import { composeInitialProps, withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';
import _adviserPortalHome from './_adviserPortalHome';

class CommissionPaymentComponent extends Component {
    openFeeBreakdown(e) {
        const windowFeatures = "width=1500, height=500"
        if (e.target.id === "feeBreakdown")
            window.open("https://local.superlife.co.nz/adv/feeBreakdown", "Fee Breakdown", windowFeatures)
    }

    _sortByDueDateDesc(obj){
        return [...obj].sort((a,b) => {const dateA = new Date(a.dueDate);
        const dateB = new Date(b.dueDate);
        return dateB - dateA;})
    }

    render() {
        const { t } = this.props;
        const commissions = _adviserPortalHome._commissionPaymentDetailsGroup(this.props)
        const pastCommission = this._sortByDueDateDesc(commissions.pastCommission)
        return (
            // style={{marginLeft:"20px", marginTop: "30px", marginBottom: "20px", paddingLeft: "100px"}}
            <div className="commissionPayment">
                <header className="adviserMenu">
                    <table className="totalMembersHeader">
                        <thead>
                            <tr>
                                <th>{t('Fees:header')}</th>
                            </tr>
                        </thead>
                    </table>

                </header>
                <table id="commissionPayment" className="superlifeLegacyPlan commissionsPayment">
                    <thead>
                        <tr>
                            <th>{t('feesTable:date')}</th>
                            <th>{t('feesTable:transactionType')}</th>
                            <th>{t('feesTable:amount')}</th>
                            <th>{t('feesTable:status')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ textAlign: "center" }}>{commissions.previous[0].dueDate}</td>
                            <td style={{ textAlign: "center" }}>{t('Fee for Service')}</td>
                            <td><CurrencyFormat value={Number(commissions.previousFee).toFixed(2)}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'} /></td>
                            <td style={{ textAlign: "center" }}><Link to={'/adv/commissionPayment/'+commissions.previous[0].startDate.replace(/\//g, "-")}>{t('Fees:paid')}</Link></td>
                        </tr>
                        <tr><hr></hr></tr>
                        {
                            pastCommission.map(commission => 
                                <tr>
                                    <td style={{ textAlign: "center" }}>{commission.dueDate}</td>
                                    <td style={{ textAlign: "center" }}>{t('Fee for Service')}</td>
                                    <td><CurrencyFormat value={Number(commission.payment).toFixed(2)}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'} /></td>
                                    <td style={{ textAlign: "center" }}><Link to={'/adv/commissionPayment/'+commission.startDate.replace(/\//g, "-")}>{t('Fees:paid')}</Link></td>
                                </tr>    
                            )
                        }
                    </tbody>
                    {/* <tbody>
                        {
                            commission.map(commission => 
                                commission.map((comm,key) => 
                                    <tr key={key}>
                                        <td style={{textAlign: "center"}}>{comm.dueDate}</td>
                                        <td style={{textAlign: "center"}}>{t('commission')+" "+t('payment')}</td>
                                        <td><CurrencyFormat value={Number(comm.payment).toFixed(2)}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'} /></td>
                                        {new Date(comm.month).getMonth() === new Date(formattedDate).getMonth() 
                                            ? <td><Link to='/adv/commissionPayment/due'>{t('due')}</Link></td> 
                                            : <td><Link to='/adv/commissionPayment/paid'>{t('paid')}</Link></td>}
                                    </tr>
                                ))}
                    </tbody> */}
                    <tr><td colSpan='4'>For statements prior to this period, please contact our team at <a href='mailTo:financialadvisers@superlife.co.nz'>financialadvisers@superlife.co.nz</a></td></tr>
                </table>

            </div>
        )
    }
}

export default withTranslation()(CommissionPaymentComponent);